import { render } from "./TargetsList.vue?vue&type=template&id=2f716324&scoped=true&ts=true"
import script from "./TargetsList.vue?vue&type=script&lang=ts"
export * from "./TargetsList.vue?vue&type=script&lang=ts"

import "./TargetsList.vue?vue&type=style&index=0&id=2f716324&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f716324"]])

export default __exports__